import { render, staticRenderFns } from "./OrderItemSummary.vue?vue&type=template&id=3bc02a2d"
import script from "./OrderItemSummary.vue?vue&type=script&lang=js"
export * from "./OrderItemSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderItemSummary.vue?vue&type=style&index=0&id=3bc02a2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports